document.addEventListener('change', function (e) {
    const inputFoto = e.target.closest('.fotoColaborador');
    if (!inputFoto) return;

    const archivo = inputFoto.files[0];
    if (!archivo) return;

    const tiposPermitidos = ['image/jpeg', 'image/png', 'image/webp'];

    if (!tiposPermitidos.includes(archivo.type)) {
        inputFoto.value = '';

        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta('Formato no permitido.', 'alerta-roja');
        } else {
            alert('Formato no permitido.');
        }

        return;
    }

    const contenedor = inputFoto.closest('.uploadFoto');
    if (!contenedor) return;

    const previewFoto = contenedor.querySelector('.previewFotoColaborador');
    if (!previewFoto) return;

    const reader = new FileReader();

    reader.onload = function (evento) {
        previewFoto.src = evento.target.result;
    };

    reader.readAsDataURL(archivo);
});